import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * CA中心&会员
 */
export default {
  path: 'services',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: 'CA中心&会员',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
    { companyType: companyTypeDict.SELF_EMPLOYEE.value },
    { companyType: companyTypeDict.PERSON.value, menuName: '会员中心' }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
  roles: [
    platformFunctionModuleDict.SUPPLIER.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: [
    // 会员中心
    {
      path: 'vip',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '会员中心',
        icon: 'icon-side_huiyuangoumai',
        layout: 'DefaultLayout'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // 会员购买
        {
          path: 'buy',
          name: 'VipBuy',
          component: '/ca/vip/vip-buy',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '会员购买'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
            { companyType: companyTypeDict.SELF_EMPLOYEE.value },
            { companyType: companyTypeDict.PERSON.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
          roles: [
            platformFunctionModuleDict.SUPPLIER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 会员主页
        {
          path: 'home',
          name: 'VipHome',
          component: '/ca/vip/vip-home',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '会员主页'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
            { companyType: companyTypeDict.SELF_EMPLOYEE.value },
            { companyType: companyTypeDict.PERSON.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
          roles: [
            platformFunctionModuleDict.SUPPLIER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 分析记录
        {
          path: 'portrait-record',
          name: 'PortraitRecord',
          component: '/ca/vip/portrait-record',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '分析记录'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
            { companyType: companyTypeDict.SELF_EMPLOYEE.value },
            { companyType: companyTypeDict.PERSON.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
          roles: [
            platformFunctionModuleDict.SUPPLIER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 标书预览记录
        {
          path: 'bid-file-preview',
          name: 'BidFilePreview',
          component: '/ca/vip/bid-file-preview',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '标书预览记录'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
            { companyType: companyTypeDict.SELF_EMPLOYEE.value },
            { companyType: companyTypeDict.PERSON.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
          roles: [
            platformFunctionModuleDict.SUPPLIER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 数据导出记录
        {
          path: 'custom-data',
          name: 'CustomData',
          component: '/ca/vip/custom-data',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '数据导出记录'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
            { companyType: companyTypeDict.SELF_EMPLOYEE.value },
            { companyType: companyTypeDict.PERSON.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
          roles: [
            platformFunctionModuleDict.SUPPLIER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        }
      ]
    },

    // 我的CA
    {
      path: 'ca',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '我的CA',
        icon: 'icon-side_ca_mine',
        layout: 'DefaultLayout'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // CA新购
        {
          path: 'buy',
          name: 'CABuy',
          component: '/ca/ca-buy',
          type: menuTypeDict.MENU.value,
          meta: {
            title: 'CA新购'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
            { companyType: companyTypeDict.SELF_EMPLOYEE.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
          roles: [
            platformFunctionModuleDict.SUPPLIER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // CA续费申领
        {
          path: 'paid',
          type: menuTypeDict.DIRECTORY.value,
          meta: {
            title: 'CA续费申领',
            layout: 'DefaultLayout'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
            { companyType: companyTypeDict.SELF_EMPLOYEE.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
          roles: [
            platformFunctionModuleDict.SUPPLIER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: [],

          children: [
            // 申领列表
            {
              path: 'list',
              name: 'CAPaidList',
              component: '/ca/ca-paid-list',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '申领列表',
                hidden: true
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
                { companyType: companyTypeDict.SELF_EMPLOYEE.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
              roles: [
                platformFunctionModuleDict.SUPPLIER.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            },

            // 续购记录
            {
              path: ':serviceCode/type/:serviceType/history',
              name: 'CAPaidHistory',
              component: '/ca/ca-paid-history',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '续购记录',
                hidden: true
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
                { companyType: companyTypeDict.SELF_EMPLOYEE.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
              roles: [
                platformFunctionModuleDict.SUPPLIER.right,
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            }
          ]
        },

        // 实体CA办理/变更
        {
          path: 'apply',
          type: menuTypeDict.DIRECTORY.value,
          meta: {
            title: '实体CA办理/变更',
            layout: 'DefaultLayout'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
            { companyType: companyTypeDict.SELF_EMPLOYEE.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
          roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
          superviseInstitutions: [],

          children: [
            // CA列表
            {
              path: 'list',
              name: 'UKeyApplyList',
              component: '/ca/ukey-apply-list',
              type: menuTypeDict.MENU.value,
              meta: {
                title: 'CA列表',
                cache: true,
                hidden: true,
                pageComponentName: 'UKeyApplyList'
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
                { companyType: companyTypeDict.SELF_EMPLOYEE.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
              roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
              superviseInstitutions: []
            },

            // CA办理
            {
              path: 'form',
              name: 'UKeyApplyForm',
              component: '/ca/ukey-apply-form',
              type: menuTypeDict.MENU.value,
              meta: {
                title: 'CA办理',
                hidden: true
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
                { companyType: companyTypeDict.SELF_EMPLOYEE.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
              roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
              superviseInstitutions: []
            },

            // CA信息变更申请
            {
              path: 'change',
              name: 'UKeyApplyChange',
              component: '/ca/ukey-apply-change',
              type: menuTypeDict.MENU.value,
              meta: {
                title: 'CA信息变更申请',
                hidden: true
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
                { companyType: companyTypeDict.SELF_EMPLOYEE.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
              roles: [platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
              superviseInstitutions: []
            },

            // CA信息变更
            {
              path: 'change/detail/:applyId',
              name: 'UKeyChangeDetail',
              component: '/ca/ukey-change-detail',
              type: menuTypeDict.MENU.value,
              meta: {
                title: 'CA信息变更',
                hidden: true
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
                { companyType: companyTypeDict.SELF_EMPLOYEE.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
              roles: [
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            },

            // 实体CA认证信息
            {
              path: 'detail/:applyId',
              name: 'UKeyApplyDetail',
              component: '/ca/ukey-apply-detail',
              type: menuTypeDict.MENU.value,
              meta: {
                title: '实体CA认证信息',
                hidden: true
              },
              applicableCompanyTypes: [
                { companyType: companyTypeDict.ENTERPRISE.value },
                { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
                { companyType: companyTypeDict.SELF_EMPLOYEE.value }
              ],
              platformAlias: [],
              applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
              roles: [
                platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
              ],
              superviseInstitutions: []
            }
          ]
        }
      ]
    },

    // 常见问题
    {
      path: 'fqa',
      name: 'CAFQA',
      component: '/ca/ca-fqa',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '常见问题',
        icon: 'icon-side_ca_question'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 投标制作客户端
    {
      path: 'bid-tool',
      name: 'BidToolDownload',
      component: '/ca/tool-download',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '投标制作客户端',
        icon: 'icon-side_ca_app'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    }
  ]
}
